module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-114x114-d40a0c32d6da958ff9026f4eeadc4437.png";